import type { ReactNode } from "react";
import React, { createContext, useContext, useState } from "react";
import type { NavLinkKey } from "./constants";

export interface NavigationContextProps {
  activeMenu: NavLinkKey | null;
  setActiveMenu: (menu: NavLinkKey | null) => void;
  isCloseButtonActive: boolean;
  setIsCloseButtonActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const NavigationContext = createContext<NavigationContextProps | undefined>(
  undefined
);

interface NavigationProviderProps {
  children: ReactNode;
  value?: NavigationContextProps;
}

export const NavigationProvider = ({
  children,
  value
}: NavigationProviderProps) => {
  const [activeMenuState, setActiveMenuState] = useState<NavLinkKey | null>(
    null
  );
  const [isCloseButtonActiveState, setIsCloseButtonActiveState] =
    useState(true);

  const contextValue = value || {
    activeMenu: activeMenuState,
    setActiveMenu: setActiveMenuState,
    isCloseButtonActive: isCloseButtonActiveState,
    setIsCloseButtonActive: setIsCloseButtonActiveState
  };

  return (
    <NavigationContext.Provider value={contextValue}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = (): NavigationContextProps => {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
};
